export default __webpack_public_path__ + "static/media/dogmap_logo_2048_color_transparent.2d7d921b.png";